import React, { PureComponent } from 'react'
import { string, shape, bool } from 'prop-types'
import ReactMarkdown from 'react-markdown'
import { Paragraph, Strong, ListItem, List } from '@ycos/primitives'
import Heading from './Heading'

const ALLOWED_TYPES = ['paragraph', 'emphasis', 'strong', 'link', 'list', 'listItem', 'heading']

class Markdown extends PureComponent {
  renderParagraph = ({ children }) => <Paragraph inverseColor={this.props.inverseColor}>{children}</Paragraph>

  renderStrong = ({ children }) => <Strong inverseColor={this.props.inverseColor}>{children}</Strong>

  render() {
    const { anchorpoint, teaserText, renderers } = this.props

    return (
      <div id={anchorpoint}>
        <ReactMarkdown
          renderers={{
            paragraph: this.renderParagraph,
            heading: Heading,
            strong: this.renderStrong,
            listItem: ListItem,
            list: List,
            ...renderers
          }}
          allowedTypes={ALLOWED_TYPES}
          source={teaserText}
        />
      </div>
    )
  }
}

Markdown.propTypes = {
  anchorpoint: string,
  teaserText: string.isRequired,
  renderers: shape(),
  inverseColor: bool
}

Markdown.defaultProps = {
  anchorpoint: null,
  renderers: {},
  inverseColor: false
}

export default Markdown
